import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const hrApiClient = axios.create({
  baseURL: `${BACKEND_URL}/api/hr`,
});

hrApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('hrToken') || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

hrApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('HR API: Unauthorized');
    }
    return Promise.reject(error);
  }
);

export default hrApiClient;
